import script from "./DatasetChangeLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetChangeLogs.vue?vue&type=script&setup=true&lang=js"

import "./DatasetChangeLogs.vue?vue&type=style&index=0&id=77826bd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77826bd6"]])

export default __exports__